export interface Settings {
	appUrl: string;
	webUrl: string;
	serverUrl: string;
	gameHeight: number;
	gameWidth: number;
	backgroundColor: string;
	env?: string;
	sessionUrl?: string;
}

const settings: Settings = {
	appUrl: "",
	webUrl: "",
	serverUrl: "",
	// Use standard 800 x 360 resolution to create aspect ratio
	gameHeight: 360,
	gameWidth: 800,
	backgroundColor: "#080F0F",
};

/**
 * Add environment settings to the shared settings object.
 * @param env - Environment type: "DEV", "STAGING", or "PROD"
 */
function init(env: "DEV" | "STAGING" | "PROD"): Settings {
	if (env === "DEV") {
		const host = window.location.hostname;
		Object.assign(settings, {
			appUrl: `http://${host}:5173/`,
			webUrl: `http://${host}:3000/`,
			serverUrl: `http://${host}:8000/`,
			env: "DEV",
		});
	} else if (env === "STAGING") {
		Object.assign(settings, {
			appUrl: "https://staging.tumbodash.pages.dev/",
			webUrl: "https://staging.tumbodash.pages.dev/",
			serverUrl: "https://tumbodash-server-staging.onrender.com/",
			env: "STAGING",
		});
	} else if (env === "PROD") {
		Object.assign(settings, {
			appUrl: "https://www.tumbodash.com/",
			webUrl: "https://www.tumbodash.com/",
			serverUrl: "https://tumbodash-server.onrender.com/",
			env: "PROD",
		});
	}
	settings.sessionUrl = settings.serverUrl + "session";
	return settings;
}

export { init };

export default settings;
